import React, { useState, useEffect, useRef } from 'react';
import { 
  Shield, ShieldCheck, Briefcase, FileText, MessageSquare, Settings, Search, Bell, User, Lock, LogOut, MoreVertical, 
  Download, Upload, Plus, CheckCircle2, Clock, Eye, Layers, X, ChevronRight, ChevronLeft, 
  FilePlus2, ArrowUp, ArrowDown, CheckSquare, CalendarDays, ArrowRight, Edit, Trash2, Save, Calendar, 
  MapPin, Gavel, Users, Receipt, Banknote, RefreshCw, Mail, Sliders, ArrowDownAZ, Image as ImageIcon, FileEdit, 
  MoveUp, MoveDown, RotateCw, Settings2, Database, UserCog, Scan, Printer, MonitorDown, Copy, FolderSync, Menu, Paperclip, ExternalLink, Folder, FolderOpen, UploadCloud
} from 'lucide-react';
import { ROLE_NAMES, formatHebDate, handleDownloadLocalFile } from '../utils';

export default function SidebarItem({ icon, label, active, onClick, badge }) {
  return (
    <button onClick={onClick} className={`w-full flex items-center justify-between p-3 rounded-lg transition-colors text-right ${active ? 'bg-blue-700 text-white shadow-md' : 'text-blue-200 hover:bg-blue-900/50 hover:text-white'}`}>
      <div className="flex items-center gap-3">
        {React.cloneElement(icon, { className: 'w-5 h-5 shrink-0' })}
        <span className="font-medium truncate">{label}</span>
      </div>
      {badge && badge !== "0" && <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full shrink-0">{badge}</span>}
    </button>
  );
}
